module.exports = __webpack_public_path__ + "static/img/warehouse06.7342309.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/warehouse06.jpg
// module id = 83jq
// module chunks = 0